var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.87 34.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: currentColor;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: .85px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: currentColor;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_3",
    "data-name": "Capa 3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 7.5,
    cy: 19.97,
    rx: 3.07,
    ry: 3.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11.41,
    y1: 30.51,
    x2: 11.41,
    y2: 34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3.79,
    y1: 30.45,
    x2: 3.79,
    y2: 33.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.43,25.1h0c3.87,0,7.01,3.14,7.01,7.01v1.14c0,.42-.34.75-.75.75H1.18c-.42,0-.75-.34-.75-.75v-1.14c0-3.87,3.14-7.01,7.01-7.01Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 23.51,
    cy: 3.96,
    rx: 3.07,
    ry: 3.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 27.42,
    y1: 14.5,
    x2: 27.42,
    y2: 17.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 19.8,
    y1: 14.44,
    x2: 19.8,
    y2: 17.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.44,9.09h0c3.87,0,7.01,3.14,7.01,7.01v1.14c0,.42-.34.75-.75.75h-12.51c-.42,0-.75-.34-.75-.75v-1.14c0-3.87,3.14-7.01,7.01-7.01Z"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "7.5 12.33 7.5 3.96 15.39 3.96"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 15.39,
    cy: 3.96,
    r: 1.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6.64,
    y: 11.66,
    width: 1.72,
    height: 1.72
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "24.74 21.09 24.74 29.47 16.85 29.47"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 16.85,
    cy: 29.47,
    r: 1.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 23.88,
    y: 20.04,
    width: 1.72,
    height: 1.72,
    transform: "translate(49.48 41.81) rotate(180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickets);
export default __webpack_public_path__ + "static/media/Tickets.3f5513d30128f57bbec03c04c18ce047.svg";
export { ForwardRef as ReactComponent };